export enum ClubMemberStatus {
  Active = 'active',
  Blocked = 'blocked',
}

/** Member projection returned by every /club member endpoint. */
export interface IClubMember {
  id: number;
  memberNumber: number;
  name: string;
  email: string | null;
  phone: string | null;
  status: ClubMemberStatus;
  pointsBalance: number;
  cashPrincipal: number;
  cashBonus: number;
  cashTotal: number;
  lifetimePoints: number;
  lifetimeSpend: number;
  visitsCount: number;
  lastVisitAt: string | null;
  createdAt: string;
}

/** Slim member projection shown in the POS order panel (no PII). */
export interface IClubOrderMember {
  id: number;
  memberNumber: number;
  name: string;
  pointsBalance: number;
  cashTotal: number;
}

export interface IClubOrderMemberContext {
  member: IClubOrderMember | null;
  /** Live staff identification grant covering the order, if any. */
  verification: { ttlSeconds: number } | null;
}

/** What a balance tender needs to know about the member. */
export type IClubTenderMember = Pick<
  IClubMember,
  'id' | 'memberNumber' | 'name' | 'cashTotal'
>;

/**
 * Draft-host result of V2ModalClubAttach: the member and the live code that
 * identified them (null for lookup picks).
 */
export interface IClubMemberIdentification {
  member: IClubMember;
  code: string | null;
}
